import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function CircleIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon viewBox="0 0 16 16" htmlColor={Color.Body} {...props}>
      <circle cx="8" cy="8" r="7" />
    </MuiSvgIcon>
  );
}
export default CircleIcon;
